import Vue from 'vue';
import { init } from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

export function useSentry (dsn) {
    init({
        dsn,
        environment: process.env.CI_ENVIRONMENT_NAME || 'local',
        release: process.env.CI_COMMIT_SHORT_SHA,
        integrations: [new VueIntegration({
            Vue,
            attachProps: true,
            logErrors: true,
        })],
        enabled: process.env.NODE_ENV === 'production',
        normalizeDepth: 10,
    });
}
